// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import t from "../i18n";

require("@rails/ujs").start()
require("turbolinks").start()
require("jquery")
require("@rails/activestorage").start()
require("channels")
require("trix")
require("chartkick")
require("chart.js")
require("select2/dist/css/select2")

import $ from 'jquery';


global.$ = $;
global.jQuery = $;
import "../channels";

import './htmx.js'; // We don't need `import "htmx.org"` anymore.
import "htmx.org/dist/ext/response-targets"
import './dashboards.js';
import 'popper.js'
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
import "@popperjs/core";
import Chartkick from "chartkick";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ahoy from "ahoy.js";
import 'cocoon-js';

import './introduction.js';
import './mobile_app.js';

import Choices from "choices.js";
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'particles.js';


import DataTable from 'datatables.net-dt';

function processHtmxFragments() {
    if (window.htmx && document.body) {
        window.htmx.process(document.body);
    }
}

document.addEventListener("turbolinks:load", processHtmxFragments);

document.addEventListener("turbolinks:load", function() {
// Initialize AOS
    AOS.init({
        duration: 1200, // Animation duration in milliseconds
        once: true,     // Whether animation should happen only once
        mirror: false   // Whether elements should animate out while scrolling past them
    });
});

function initializePublicDiscoveryMotion() {
    const discovery = document.querySelector(".public-discovery");
    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!discovery || reduceMotion) return;

    let ticking = false;

    const update = () => {
        const scrollY = Math.min(window.scrollY || window.pageYOffset || 0, 1200);
        document.documentElement.style.setProperty("--public-discovery-parallax-y", `${Math.round(scrollY * -0.035)}px`);
        ticking = false;
    };

    const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", requestUpdate, { passive: true });
}

document.addEventListener("turbolinks:load", initializePublicDiscoveryMotion);

document.addEventListener("turbolinks:load", function() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipTriggerEl) => {
        if (tooltipTriggerEl.closest("#sidebar")) return;

        bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl);
    });
});

function initializeDeferredFragments() {
    document.querySelectorAll("[data-deferred-url]").forEach((fragment) => {
        if (fragment.dataset.deferredState === "loading" || fragment.dataset.deferredState === "loaded") return;

        const url = fragment.dataset.deferredUrl;
        if (!url) return;

        fragment.dataset.deferredState = "loading";
        fragment.setAttribute("aria-busy", "true");
        fragment.classList.add("is-loading");

        fetch(url, {
            credentials: "same-origin",
            headers: {
                "Accept": "text/html",
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then((response) => {
                if (!response.ok) throw new Error(`Deferred fragment failed: ${response.status}`);
                return response.text();
            })
            .then((html) => {
                fragment.innerHTML = html;
                fragment.dataset.deferredState = "loaded";
                fragment.classList.remove("is-loading");
                fragment.classList.add("is-loaded");
                fragment.removeAttribute("aria-busy");
                initializeDeferredFragmentContent(fragment);
            })
            .catch((error) => {
                console.error(error);
                fragment.dataset.deferredState = "failed";
                fragment.classList.remove("is-loading");
                fragment.classList.add("is-failed");
                fragment.removeAttribute("aria-busy");

                const fallback = document.createElement("div");
                fallback.className = "deferred-fragment__error";
                fallback.textContent = fragment.dataset.deferredError || t("common.loading_failed", {}, "Daten konnten nicht geladen werden.");
                fragment.innerHTML = "";
                fragment.appendChild(fallback);
            });
    });
}

function initializeDeferredFragmentContent(fragment) {
    if (window.bootstrap) {
        fragment.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipTriggerEl) => {
            window.bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl);
        });
    }

    if (typeof initializeFlatpickr === "function") initializeFlatpickr();
    if (typeof initializechoicesselect === "function") initializechoicesselect();

    document.dispatchEvent(new CustomEvent("deferred:loaded", { detail: { fragment } }));
}

document.addEventListener("DOMContentLoaded", initializeDeferredFragments);
document.addEventListener("turbolinks:load", initializeDeferredFragments);
document.addEventListener("htmx:afterSwap", initializeDeferredFragments);

function initializeBackendBootstrap() {
    if (!document.body || !document.body.classList.contains("backend-shell") || !window.bootstrap) return;

    document.querySelectorAll(".backend-flash [data-bs-dismiss='alert']").forEach((button) => {
        if (button.dataset.backendBootstrapBound === "true") return;
        button.dataset.backendBootstrapBound = "true";

        button.addEventListener("click", (event) => {
            const flash = event.target.closest(".backend-flash");
            if (flash) flash.remove();
        });
    });

    document.querySelectorAll("[data-bs-toggle='tooltip']").forEach((element) => {
        window.bootstrap.Tooltip.getOrCreateInstance(element);
    });

    document.querySelectorAll("[data-backend-modal-target]").forEach((trigger) => {
        if (trigger.dataset.backendBootstrapBound === "true") return;
        trigger.dataset.backendBootstrapBound = "true";

        trigger.addEventListener("click", (event) => {
            const target = document.querySelector(trigger.dataset.backendModalTarget);
            if (!target) return;

            if (!trigger.hasAttribute("hx-get") && !trigger.hasAttribute("data-hx-get")) {
                event.preventDefault();
            }
            window.bootstrap.Modal.getOrCreateInstance(target).show();
        });
    });

    document.querySelectorAll("[data-backend-offcanvas-target]").forEach((trigger) => {
        if (trigger.dataset.backendBootstrapBound === "true") return;
        trigger.dataset.backendBootstrapBound = "true";

        trigger.addEventListener("click", (event) => {
            const target = document.querySelector(trigger.dataset.backendOffcanvasTarget);
            if (!target) return;

            if (!trigger.hasAttribute("hx-get") && !trigger.hasAttribute("data-hx-get")) {
                event.preventDefault();
            }
            window.bootstrap.Offcanvas.getOrCreateInstance(target).show();
        });
    });
}

document.addEventListener("turbolinks:load", initializeBackendBootstrap);
document.addEventListener("htmx:afterSwap", initializeBackendBootstrap);
document.addEventListener("htmx:load", initializeBackendBootstrap);

document.addEventListener('turbolinks:load', function () {
    var tooltipElement = document.getElementById('tooltip-element');
    if (tooltipElement) {
        new bootstrap.Tooltip(tooltipElement);
    }

});

document.addEventListener("turbolinks:load", function () {
    if (!document.getElementById("particles-js")) return;

    // If using a config file
    particlesJS("particles-js", {
        "particles": {
            "number": {"value": 10, "density": {"enable": false, "value_area": 100}},
            "color": {"value": "#93c5fd"},
            "shape": {
                "type": "circle",
                "stroke": {"width": 1, "color": "#e5e7eb"},
                "polygon": {"nb_sides": 30},
                "image": {"src": "img/github.svg", "width": 100, "height": 100}
            },
            "opacity": {
                "value": 0.8,
                "random": false,
                "anim": {"enable": false, "speed": 1, "opacity_min": 0.1, "sync": false}
            },
            "size": {
                "value": 6,
                "random": true,
                "anim": {"enable": false, "speed": 20, "size_min": 0.1, "sync": false}
            },
            "line_linked": {
                "enable": true,
                "distance": 600,
                "color": "#dbeafe",
                "opacity": 0.5,
                "width": 1
            },
            "move": {
                "enable": true,
                "speed": 1,
                "direction": "none",
                "random": true,
                "straight": false,
                "out_mode": "bounce",
                "bounce": false,
                "attract": {"enable": false, "rotateX": 2966.312312601217, "rotateY": 1763.753266952075}
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {
                "onhover": {"enable": true, "mode": "repulse"},
                "onclick": {"enable": true, "mode": "push"},
                "resize": true
            },
            "modes": {
                "grab": {"distance": 400, "line_linked": {"opacity": 1}},
                "bubble": {"distance": 400, "size": 40, "duration": 2, "opacity": 8, "speed": 3},
                "repulse": {"distance": 200, "duration": 0.4},
                "push": {"particles_nb": 4},
                "remove": {"particles_nb": 2}
            }
        },
        "retina_detect": true
    });



});

document.addEventListener("turbolinks:load", function () {
    if (!document.getElementById("particles-js-2")) return;

    // If using a config file
    particlesJS("particles-js-2", {
        "particles": {
            "number": {"value": 10, "density": {"enable": false, "value_area": 100}},
            "color": {"value": "#93c5fd"},
            "shape": {
                "type": "circle",
                "stroke": {"width": 1, "color": "#e5e7eb"},
                "polygon": {"nb_sides": 30},
                "image": {"src": "img/github.svg", "width": 100, "height": 100}
            },
            "opacity": {
                "value": 0.8,
                "random": false,
                "anim": {"enable": false, "speed": 1, "opacity_min": 0.1, "sync": false}
            },
            "size": {
                "value": 6,
                "random": true,
                "anim": {"enable": false, "speed": 20, "size_min": 0.1, "sync": false}
            },
            "line_linked": {
                "enable": true,
                "distance": 600,
                "color": "#dbeafe",
                "opacity": 0.5,
                "width": 1
            },
            "move": {
                "enable": true,
                "speed": 1,
                "direction": "none",
                "random": true,
                "straight": false,
                "out_mode": "bounce",
                "bounce": false,
                "attract": {"enable": false, "rotateX": 2966.312312601217, "rotateY": 1763.753266952075}
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {
                "onhover": {"enable": true, "mode": "repulse"},
                "onclick": {"enable": true, "mode": "push"},
                "resize": true
            },
            "modes": {
                "grab": {"distance": 400, "line_linked": {"opacity": 1}},
                "bubble": {"distance": 400, "size": 40, "duration": 2, "opacity": 8, "speed": 3},
                "repulse": {"distance": 200, "duration": 0.4},
                "push": {"particles_nb": 4},
                "remove": {"particles_nb": 2}
            }
        },
        "retina_detect": true
    });



});


$(document).on('hidden.bs.modal', '.my-select2-modal', function () {
    // Restore the original enforceFocus behavior when the modal is closed
    $.fn.modal.Constructor.prototype._enforceFocus = $.fn.modal.Constructor.prototype.enforceFocus;
});

function dashboardPolishOptions(chart) {
    const configuredOptions = chart &&
        chart.config &&
        chart.config.options &&
        chart.config.options.plugins &&
        chart.config.options.plugins.dashboardPolish
        ? chart.config.options.plugins.dashboardPolish
        : {};

    if (configuredOptions.enabled === false) return null;

    return {
        enabled: true,
        barRadius: configuredOptions.barRadius || 7,
        centerLabel: configuredOptions.centerLabel || "Gesamt",
        lineFillAlpha: typeof configuredOptions.lineFillAlpha === "number" ? configuredOptions.lineFillAlpha : 0.02,
        palette: configuredOptions.palette || ["#0b5cad", "#1a73e8", "#34a853", "#fbbc04", "#ea4335", "#7baaf7", "#5f6368"]
    };
}

function dashboardHexToRgba(color, alpha) {
    if (!color || color.indexOf("#") !== 0) return color;

    const hex = color.replace("#", "");
    const normalized = hex.length === 3
        ? hex.split("").map(function (part) { return part + part; }).join("")
        : hex;

    const value = parseInt(normalized, 16);
    const red = (value >> 16) & 255;
    const green = (value >> 8) & 255;
    const blue = value & 255;

    return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
}

function dashboardGradient(chart, color, startAlpha, endAlpha, horizontal) {
    if (!chart.chartArea) return dashboardHexToRgba(color, startAlpha);

    const area = chart.chartArea;
    const ctx = chart.ctx;
    const gradient = horizontal
        ? ctx.createLinearGradient(area.left, 0, area.right, 0)
        : ctx.createLinearGradient(0, area.top, 0, area.bottom);

    gradient.addColorStop(0, dashboardHexToRgba(color, startAlpha));
    gradient.addColorStop(1, dashboardHexToRgba(color, endAlpha));
    return gradient;
}

function dashboardFormatNumber(value) {
    const number = Number(value || 0);
    const abs = Math.abs(number);

    if (abs >= 1000000) {
        return (number / 1000000).toLocaleString("de-DE", { maximumFractionDigits: 1 }) + " Mio.";
    }

    if (abs >= 1000) {
        return (number / 1000).toLocaleString("de-DE", { maximumFractionDigits: 1 }) + " Tsd.";
    }

    return number.toLocaleString("de-DE", { maximumFractionDigits: 0 });
}

function dashboardRoundedBarPath(ctx, left, top, right, bottom, radius, corners) {
    ctx.beginPath();
    ctx.moveTo(left + (corners.topLeft ? radius : 0), top);
    ctx.lineTo(right - (corners.topRight ? radius : 0), top);
    corners.topRight ? ctx.quadraticCurveTo(right, top, right, top + radius) : ctx.lineTo(right, top);
    ctx.lineTo(right, bottom - (corners.bottomRight ? radius : 0));
    corners.bottomRight ? ctx.quadraticCurveTo(right, bottom, right - radius, bottom) : ctx.lineTo(right, bottom);
    ctx.lineTo(left + (corners.bottomLeft ? radius : 0), bottom);
    corners.bottomLeft ? ctx.quadraticCurveTo(left, bottom, left, bottom - radius) : ctx.lineTo(left, bottom);
    ctx.lineTo(left, top + (corners.topLeft ? radius : 0));
    corners.topLeft ? ctx.quadraticCurveTo(left, top, left + radius, top) : ctx.lineTo(left, top);
    ctx.closePath();
}

function patchDashboardRoundedBars(ChartRef) {
    if (!ChartRef.elements || !ChartRef.elements.Rectangle || ChartRef.elements.Rectangle.prototype.dashboardRoundedBars) return;

    const originalDraw = ChartRef.elements.Rectangle.prototype.draw;

    ChartRef.elements.Rectangle.prototype.draw = function () {
        const polishOptions = dashboardPolishOptions(this._chart);
        if (!polishOptions) return originalDraw.apply(this, arguments);

        const ctx = this._chart.ctx;
        const view = this._view;
        if (!ctx || !view) return originalDraw.apply(this, arguments);

        let left;
        let right;
        let top;
        let bottom;
        let corners;

        if (view.horizontal) {
            left = Math.min(view.base, view.x);
            right = Math.max(view.base, view.x);
            top = view.y - (view.height / 2);
            bottom = view.y + (view.height / 2);
            corners = view.x >= view.base
                ? { topLeft: false, topRight: true, bottomRight: true, bottomLeft: false }
                : { topLeft: true, topRight: false, bottomRight: false, bottomLeft: true };
        } else {
            left = view.x - (view.width / 2);
            right = view.x + (view.width / 2);
            top = Math.min(view.base, view.y);
            bottom = Math.max(view.base, view.y);
            corners = view.y <= view.base
                ? { topLeft: true, topRight: true, bottomRight: false, bottomLeft: false }
                : { topLeft: false, topRight: false, bottomRight: true, bottomLeft: true };
        }

        const width = right - left;
        const height = bottom - top;
        if (width < 2 || height < 2) return originalDraw.apply(this, arguments);

        const radius = Math.min(Number(polishOptions.barRadius || 8), width / 2, height / 2);
        ctx.save();
        ctx.fillStyle = view.backgroundColor;
        ctx.strokeStyle = view.borderColor;
        ctx.lineWidth = view.borderWidth || 0;
        dashboardRoundedBarPath(ctx, left, top, right, bottom, radius, corners);
        ctx.fill();
        if (view.borderWidth) ctx.stroke();
        ctx.restore();
    };

    ChartRef.elements.Rectangle.prototype.dashboardRoundedBars = true;
}

const DashboardChartPolish = {
    id: "dashboardPolish",

    beforeDraw: function (chart) {
        const polishOptions = dashboardPolishOptions(chart);
        if (!polishOptions || !chart.chartArea) return;
        if (chart.config.type === "doughnut" || chart.config.type === "pie") return;

        const area = chart.chartArea;
        const ctx = chart.ctx;
        ctx.save();
        ctx.fillStyle = "rgba(255, 255, 255, 0.72)";
        ctx.fillRect(area.left, area.top, area.right - area.left, area.bottom - area.top);
        ctx.restore();
    },

    beforeDatasetsDraw: function (chart) {
        const polishOptions = dashboardPolishOptions(chart);
        if (!polishOptions || !chart.chartArea || !chart.data || !chart.data.datasets) return;

        const palette = polishOptions.palette || ["#0b5cad", "#1a73e8", "#34a853", "#fbbc04", "#ea4335", "#7baaf7", "#5f6368"];
        const chartType = chart.config.type;
        const isLine = chartType === "line";
        const isBar = chartType === "bar" || chartType === "horizontalBar";
        const isDonut = chartType === "doughnut" || chartType === "pie";

        chart.data.datasets.forEach(function (dataset, index) {
            const color = palette[index % palette.length];
            const horizontal = chartType === "horizontalBar";

            dataset.borderColor = dataset.borderColor || color;
            dataset.hoverBorderColor = "#ffffff";

            if (isDonut) {
                dataset.backgroundColor = (dataset.data || []).map(function (_value, itemIndex) {
                    return dashboardHexToRgba(palette[itemIndex % palette.length], 0.92);
                });
                dataset.hoverBackgroundColor = (dataset.data || []).map(function (_value, itemIndex) {
                    return dashboardHexToRgba(palette[itemIndex % palette.length], 1);
                });
                dataset.borderColor = "#ffffff";
                dataset.borderWidth = 2;
                return;
            }

            if (isLine) {
                const fillAlpha = dataset.fill ? 0.16 : polishOptions.lineFillAlpha;
                dataset.backgroundColor = dashboardGradient(chart, color, fillAlpha, 0.0, false);
                dataset.borderColor = color;
                dataset.borderWidth = dataset.borderWidth || 2;
                dataset.pointBackgroundColor = "#ffffff";
                dataset.pointBorderColor = color;
                dataset.pointHoverBackgroundColor = color;
                dataset.pointHoverBorderColor = "#ffffff";
                dataset.pointRadius = dataset.pointRadius || 0;
                dataset.pointHoverRadius = dataset.pointHoverRadius || 4;
                return;
            }

            if (isBar) {
                dataset.backgroundColor = dashboardGradient(chart, color, 0.88, 0.55, horizontal);
                dataset.borderColor = dashboardHexToRgba(color, 0.95);
                dataset.hoverBackgroundColor = dashboardHexToRgba(color, 1);
                dataset.borderWidth = 1;
            }
        });
    },

    afterDraw: function (chart) {
        const polishOptions = dashboardPolishOptions(chart);
        if (!polishOptions) return;

        if (chart.config.type === "doughnut" || chart.config.type === "pie") {
            const dataset = chart.data && chart.data.datasets && chart.data.datasets[0];
            const meta = chart.getDatasetMeta(0);
            const firstSlice = meta && meta.data && meta.data[0];
            if (!dataset || !firstSlice) return;

            const center = firstSlice._model || firstSlice._view;
            const total = (dataset.data || []).reduce(function (sum, value) {
                return sum + Number(value || 0);
            }, 0);

            const ctx = chart.ctx;
            ctx.save();
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = "#111827";
            ctx.font = "600 22px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
            ctx.fillText(dashboardFormatNumber(total), center.x, center.y - 4);
            ctx.fillStyle = "#6b7280";
            ctx.font = "500 11px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
            ctx.fillText(polishOptions.centerLabel || "Gesamt", center.x, center.y + 18);
            ctx.restore();
            return;
        }

        if (chart.config.type !== "line" || !chart.data || !chart.data.datasets) return;

        const palette = polishOptions.palette || ["#0b5cad", "#1a73e8", "#34a853", "#fbbc04", "#ea4335", "#7baaf7", "#5f6368"];
        chart.data.datasets.forEach(function (_dataset, index) {
            const meta = chart.getDatasetMeta(index);
            if (!meta || meta.hidden || !meta.data || !meta.data.length) return;

            const point = meta.data.slice().reverse().find(function (item) {
                const view = item._view || item._model;
                return view && !view.skip;
            });
            if (!point) return;

            const view = point._view || point._model;
            const color = palette[index % palette.length];
            const ctx = chart.ctx;
            ctx.save();
            ctx.beginPath();
            ctx.arc(view.x, view.y, 6, 0, Math.PI * 2);
            ctx.fillStyle = dashboardHexToRgba(color, 0.16);
            ctx.fill();
            ctx.beginPath();
            ctx.arc(view.x, view.y, 3.2, 0, Math.PI * 2);
            ctx.fillStyle = color;
            ctx.fill();
            ctx.restore();
        });
    }
};

patchDashboardRoundedBars(Chart);
Chart.plugins.register(ChartDataLabels);
Chart.plugins.register(DashboardChartPolish);

Chart.defaults.global.defaultFontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
Chart.defaults.global.defaultFontColor = "#5f6368";
Chart.defaults.global.elements.line.borderCapStyle = "round";
Chart.defaults.global.elements.line.borderJoinStyle = "round";
Chart.defaults.global.elements.line.tension = 0.36;
Chart.defaults.global.elements.point.radius = 0;
Chart.defaults.global.elements.point.hoverRadius = 4;

Chart.defaults.global.plugins.datalabels = {
    display: false,
    color: "#111827",
    offset: 5,
    align: "end",
    anchor: "center",
    font: {
        size: 12,
        weight: "600"
    },
    formatter: function (value) {
        return value;
    }
};

// Add Chartkick adapter
Chartkick.addAdapter(Chart);

// Set global options for Chartkick
Chartkick.options = {
    colors: ["#0b5cad", "#1a73e8", "#34a853", "#fbbc04", "#ea4335", "#7baaf7", "#5f6368"],
    library: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
            easing: "easeOutCubic",
            duration: 900
        },
        hover: {
            animationDuration: 180
        },
        responsiveAnimationDuration: 240,
        layout: {
            padding: {
                left: 4,
                right: 12,
                top: 8,
                bottom: 0
            }
        },
        legend: {
            position: "bottom",
            labels: {
                boxWidth: 8,
                fontColor: "#5f6368",
                padding: 18,
                usePointStyle: true
            }
        },
        elements: {
            line: {
                tension: 0.36,
                borderWidth: 2
            },
            point: {
                radius: 0,
                hoverRadius: 4,
                hitRadius: 12
            },
            rectangle: {
                borderSkipped: "bottom"
            }
        },
        tooltips: {
            backgroundColor: "#111827",
            bodyFontColor: "#ffffff",
            bodySpacing: 6,
            borderColor: "rgba(255, 255, 255, 0.12)",
            borderWidth: 1,
            caretPadding: 8,
            cornerRadius: 8,
            displayColors: false,
            titleFontColor: "#ffffff",
            xPadding: 12,
            yPadding: 10
        },
        scales: {
            xAxes: [{
                gridLines: {
                    borderDash: [3, 4],
                    color: "rgba(95, 99, 104, 0.14)",
                    drawBorder: false,
                    zeroLineColor: "rgba(95, 99, 104, 0.16)"
                },
                ticks: {
                    fontColor: "#5f6368",
                    maxRotation: 0,
                    padding: 8
                }
            }],
            yAxes: [{
                gridLines: {
                    borderDash: [3, 4],
                    color: "rgba(95, 99, 104, 0.14)",
                    drawBorder: false,
                    zeroLineColor: "rgba(95, 99, 104, 0.16)"
                },
                ticks: {
                    beginAtZero: true,
                    fontColor: "#5f6368",
                    padding: 8,
                    precision: 0
                }
            }]
        },
        plugins: {
            datalabels: {
                display: false
            },
            dashboardPolish: {
                enabled: true,
                barRadius: 4,
                centerLabel: "Gesamt",
                lineFillAlpha: 0.02,
                palette: ["#0b5cad", "#1a73e8", "#34a853", "#fbbc04", "#ea4335", "#7baaf7", "#5f6368"]
            }
        }
    }
};

function initializeDashboardChartDownloads(root) {
    const scope = root || document;

    scope.querySelectorAll("[data-dashboard-chart-download]").forEach(function (button) {
        if (button.dataset.dashboardChartDownloadBound === "true") return;
        button.dataset.dashboardChartDownloadBound = "true";

        button.addEventListener("click", function (event) {
            const trigger = event.currentTarget;
            const chartId = trigger.dataset.dashboardChartId;
            const chartkick = window.Chartkick || Chartkick;
            const chart = chartkick && chartkick.charts && chartkick.charts[chartId];

            if (!chart || typeof chart.toImage !== "function") return;

            const downloadOptions = {};
            if (trigger.dataset.dashboardChartBackground) {
                downloadOptions.background = trigger.dataset.dashboardChartBackground;
            }

            const image = chart.toImage(downloadOptions);
            if (!image) return;

            const link = document.createElement("a");
            const filename = trigger.dataset.dashboardChartFilename || "dashboard_chart.png";
            link.href = image;
            link.download = filename.endsWith(".png") ? filename : filename + ".png";
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            link.remove();
        });
    });
}

document.addEventListener("turbolinks:load", function () {
    initializeDashboardChartDownloads(document);
});

document.addEventListener("htmx:afterSwap", function (event) {
    initializeDashboardChartDownloads(event.target);
});

ahoy.configure({
    urlPrefix: "",
    visitsUrl: "/ahoy/visits",
    eventsUrl: "/ahoy/events",
    page: null,
    platform: "Web",
    useBeacon: true,
    startOnReady: true,
    trackVisits: true,
    cookies: false,
    cookieDomain: null,
    headers: {},
    visitParams: {},
    withCredentials: false
});

ahoy.trackAll();

window.setTimeout(function () {
    $(".alert").fadeTo(1000, 0).slideUp(1000, function () {
        $(this).remove();
    });
}, 5000);


/*
document.addEventListener("turbolinks:load", () =>{

if (document.documentElement.hasAttribute('data-turbolinks-preview')) {
    Chartkick.eachChart(function (chart) {
      chart.updateData(null)
      chart.setOptions({...chart.getOptions(), ...{library: {animation: false}}})
    })
  }

  });


*/
// Add this code to your JavaScript file


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

if (navigator.serviceWorker) {
    navigator.serviceWorker.register('/serviceworker.js', {scope: './'})
        .then(function (reg) {
            console.log('[Page] Service worker registered!');
        });
}
document.addEventListener("turbolinks:load", () => {

    $('#nav-tab a').on('click', function (e) {
        e.preventDefault()
        $(this).tab('show')
    })
});

//cookie consent
function initializeCookieConsent() {
    const rejectAllBtn = document.getElementById('rejectAllCookies');
    const acceptSelectedBtn = document.getElementById('acceptSelectedCookies');
    const cookieAllowDirect = document.getElementById('cookieAllowDirect');
    const cookieRejectDirect = document.getElementById('cookieRejectDirect');
    const cookieConsentModal = document.getElementById('cookieConsentModal');

    function bindOnce(button, handler) {
        if (!button || button.dataset.cookieConsentBound === "true") return;
        button.dataset.cookieConsentBound = "true";
        button.addEventListener('click', handler);
    }

    bindOnce(rejectAllBtn, () => {
        setCookiePreferences({analytics: false});
    });

    bindOnce(acceptSelectedBtn, () => {
        const analyticsInput = document.getElementById('analyticsCookies');
        setCookiePreferences({analytics: Boolean(analyticsInput && analyticsInput.checked)});
    });

    bindOnce(cookieAllowDirect, () => {
        setCookiePreferences({analytics: true});
    });

    bindOnce(cookieRejectDirect, () => {
        setCookiePreferences({analytics: false});
    });

    if (cookieConsentModal && cookieConsentModal.dataset.cookieConsentModalBound !== "true") {
        cookieConsentModal.dataset.cookieConsentModalBound = "true";
        cookieConsentModal.addEventListener('show.bs.modal', () => {
            document.body.classList.add('cookie-consent-modal-open');
        });
        cookieConsentModal.addEventListener('hidden.bs.modal', () => {
            document.body.classList.remove('cookie-consent-modal-open');
        });
    }

    function setCookiePreferences(preferences) {
        const cookieValue = encodeURIComponent(JSON.stringify(preferences));
        const secureFlag = window.location.protocol === "https:" ? "; secure" : "";
        document.cookie = `cookie_preferences=${cookieValue}; path=/; max-age=31536000; SameSite=Lax${secureFlag}`;

        const overlay = document.getElementById('cookieConsentOverlay');
        if (overlay) overlay.remove();

        window.setTimeout(() => location.reload(), 40);
    }
}

document.addEventListener('DOMContentLoaded', initializeCookieConsent);
document.addEventListener('turbolinks:load', initializeCookieConsent);


document.addEventListener("turbolinks:load", () => {


    $(".panel-heading").mouseenter(function () {
        $(".panel-collapse").collapse("show");
    });
    $(".panel-collapse").mouseleave(function () {
        $(".panel-collapse").collapse("hide");
    });

});


document.addEventListener("turbolinks:load", () => {


    $('#addresses').on('cocoon:before-insert', function (e, el_to_add) {
        return el_to_add.fadeIn(1000);
    });
    $('#addresses').on('cocoon:after-insert', function (e, added_el) {
        added_el.effect('highlight', {}, 500);
        return recount();
    });
    $('#addresses').on('cocoon:before-remove', function (e, el_to_remove) {
        $(this).data('remove-timeout', 1000);
        return el_to_remove.fadeOut(1000);
    });
    return $('#addresses').on('cocoon:after-remove', function (e, removed_el) {
        return recount();
    });
});

//checkboxes
document.addEventListener('turbolinks:load', function () {
    // Get the select all checkbox
    const selectAllCheckbox = document.getElementById('select-all');
    if (!selectAllCheckbox) return;

    // Get all individual row checkboxes
    const checkboxes = document.querySelectorAll('.select-checkbox');

    // Add event listener to the select all checkbox
    selectAllCheckbox.addEventListener('change', function () {
        const isChecked = this.checked;

        // Set all checkboxes to the same state as the select all checkbox
        checkboxes.forEach(function (checkbox) {
            checkbox.checked = isChecked;
            toggleRowHighlight(checkbox);
            toggleIcon(checkbox);
        });
    });

    // Add event listener to each individual checkbox
    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            toggleRowHighlight(this);
            toggleIcon(this);

            // Optionally, uncheck the "Select All" checkbox if any single checkbox is unchecked
            if (!this.checked) {
                selectAllCheckbox.checked = false;
            }
            // Check "Select All" if all are checked
            else if (Array.from(checkboxes).every(chk => chk.checked)) {
                selectAllCheckbox.checked = true;
            }
        });

        // Add click event to the row containing the checkbox
        const row = checkbox.closest('.selectable-row');
        row.addEventListener('click', function (event) {
            // Avoid triggering when clicking directly on the checkbox
            if (event.target.type !== 'checkbox') {
                checkbox.checked = !checkbox.checked;
                toggleRowHighlight(checkbox);
                toggleIcon(checkbox);

                // Adjust the "Select All" checkbox state based on individual row selection
                if (!checkbox.checked) {
                    selectAllCheckbox.checked = false;
                } else if (Array.from(checkboxes).every(chk => chk.checked)) {
                    selectAllCheckbox.checked = true;
                }
            }
        });
    });

    // Function to toggle the row highlight based on the checkbox state
    function toggleRowHighlight(checkbox) {
        const row = checkbox.closest('.selectable-row');
        if (checkbox.checked) {
            row.classList.add('selected');
        } else {
            row.classList.remove('selected');
        }
    }

    // Function to toggle the icon between checked and plus
    function toggleIcon(checkbox) {
        const row = checkbox.closest('.selectable-row');
        const uncheckedIcon = row.querySelector('.icon-unchecked');
        const checkedIcon = row.querySelector('.icon-checked');
        if (checkbox.checked) {
            uncheckedIcon.style.display = 'none';
            checkedIcon.style.display = 'inline';
        } else {
            uncheckedIcon.style.display = 'inline';
            checkedIcon.style.display = 'none';
        }
    }
});

document.addEventListener('turbolinks:load', function () {
    // Handle checkbox change events
    document.addEventListener('change', function (event) {
        if (event.target.matches('.my-checkbox')) {
            const checkbox = event.target;
            const parent = checkbox.parentElement;

            const uncheckedIcon = parent.querySelector('.icon-unchecked');
            const checkedIcon = parent.querySelector('.icon-checked');

            if (checkbox.checked) {
                uncheckedIcon.style.display = 'none';
                checkedIcon.style.display = 'inline';
            } else {
                uncheckedIcon.style.display = 'inline';
                checkedIcon.style.display = 'none';
            }
        }
    });

    // Handle icon click events
    document.addEventListener('click', function (event) {
        const icon = event.target.closest('.icon-unchecked, .icon-checked');
        if (icon) {
            const parent = icon.closest('.checkbox-container');
            const checkbox = parent.querySelector('.my-checkbox');

            // Toggle the checkbox state
            checkbox.checked = !checkbox.checked;

            // Trigger the change event on the checkbox to update icons
            const changeEvent = new Event('change', {bubbles: true});
            checkbox.dispatchEvent(changeEvent);
        }
    });
});




document.addEventListener('turbolinks:load', function () {
    var loadingIndicator = document.getElementById('loading-spinner');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
    }

    // Event Listener for all forms
    var forms = document.querySelectorAll('form');
    forms.forEach(function (form) {
        form.addEventListener('submit', function () {
            // Show loading indicator
            if (loadingIndicator) {
                loadingIndicator.style.display = 'flex';
            }
        });
    });

    // Event Listener for links with the class 'load-trigger'
    var loadTriggerLinks = document.querySelectorAll('.load-trigger');
    loadTriggerLinks.forEach(function (link) {
        link.addEventListener('click', function () {
            // Show loading indicator
            if (loadingIndicator) {
                loadingIndicator.style.display = 'flex';
            }
        });
    });
});

document.addEventListener('turbolinks:request-start', function () {
    var loadingIndicator = document.getElementById('loading-spinner');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'flex';
    }
});

document.addEventListener('turbolinks:before-render', function () {
    var loadingIndicator = document.getElementById('loading-spinner');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'flex';
    }
});

document.addEventListener('turbolinks:visit', function () {
    var loadingIndicator = document.getElementById('loading-spinner');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'flex';
    }
});
document.addEventListener('htmx:afterOnLoad', function () {
    var loadingIndicator = document.getElementById('loading-spinner');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
    }
});
document.addEventListener('htmx:afterSwap', function () {
    var loadingIndicator = document.getElementById('loading-spinner');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
    }
});

document.addEventListener('htmx:afterSettle', function () {
    var loadingIndicator = document.getElementById('loading-spinner');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
    }
});

document.addEventListener('htmx:load', function () {
    var loadingIndicator = document.getElementById('loading-spinner');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
    }
});




function initializeFlatpickr() {
    if (typeof flatpickr !== "function") return;

    document.querySelectorAll(".selector").forEach((element) => {
        if (element._flatpickr) return;

        flatpickr(element, {
            locale: {
                firstDayOfWeek: 1
            },
            minDate: "today",
            altFormat: "j. F Y, H:i",
            enableTime: true,
            dateFormat: "d.m.Y H:i",
            time_24hr: true,
            minTime: "5:00",
            maxTime: "23:00",
            weekNumbers: true
        });
    });

    document.querySelectorAll(".custom_selector").forEach((element) => {
        if (element._flatpickr) return;

        flatpickr(element, {
            locale: {
                firstDayOfWeek: 1
            },
            maxDate: "today",
            altFormat: "j. F Y, H:i",
            weekNumbers: true
        });
    });
}

// Initialize on initial page load and Turbolinks navigations
document.addEventListener("turbolinks:load", initializeFlatpickr);
document.addEventListener('htmx:afterOnLoad', initializeFlatpickr);
document.addEventListener('htmx:afterSwap', initializeFlatpickr);
document.addEventListener('htmx:afterSettle', initializeFlatpickr);
document.addEventListener('htmx:load', initializeFlatpickr);


function initializechoicesselect() {
    // Apply Choices.js to select elements with the "choices-select" class
    const elements = document.querySelectorAll(".choices-select");
    elements.forEach((element) => {
        if (element.dataset.choicesReady === "true") return;

        const choices = new Choices(element, {
            removeItemButton: true,
            searchEnabled: true.valueOf(),
            addChoices: true,
            addItems: true,
            itemSelectText: "",

        });
        element.choicesInstance = choices;
        element.dataset.choicesReady = "true";
    });
}

window.initializechoicesselect = initializechoicesselect;

document.addEventListener("turbolinks:load", initializechoicesselect);
document.addEventListener('htmx:afterOnLoad', initializechoicesselect);
document.addEventListener('htmx:afterSwap', initializechoicesselect);
document.addEventListener('htmx:afterSettle', initializechoicesselect);
document.addEventListener('htmx:load', initializechoicesselect);


function initializeSidebarState() {
    const sidebar = document.getElementById("sidebar");
    const content = document.getElementById("content");
    const desktopToggleButtons = Array.from(document.querySelectorAll("[data-sidebar-toggle]"));
    const mobileToggleButtons = Array.from(document.querySelectorAll("[data-mobile-sidebar-toggle]"));
    const mobileBackdrop = document.querySelector("[data-mobile-sidebar-backdrop]");

    if (!sidebar || !content || (desktopToggleButtons.length === 0 && mobileToggleButtons.length === 0)) return;

    const storageKey = "acvire.sidebar.state";
    const legacyStorageKey = "acvire.sidebar.collapsed";
    const mobileMediaQuery = window.matchMedia("(max-width: 780px)");

    function isMobileSidebar() {
        return mobileMediaQuery.matches;
    }

    function sidebarIsCollapsed() {
        try {
            const state = localStorage.getItem(storageKey);
            localStorage.removeItem(legacyStorageKey);
            return state === "collapsed";
        } catch (error) {
            return false;
        }
    }

    function persistSidebarState(collapsed) {
        try {
            localStorage.setItem(storageKey, collapsed ? "collapsed" : "expanded");
            localStorage.removeItem(legacyStorageKey);
        } catch (error) {
            return;
        }
    }

    function disposeSidebarTooltips() {
        sidebar.querySelectorAll("[data-bs-title], [title]").forEach((element) => {
            const tooltip = bootstrap.Tooltip.getInstance(element);
            if (tooltip) tooltip.dispose();
        });
    }

    function enableSidebarTooltips() {
        sidebar.querySelectorAll("[data-bs-title]").forEach((element) => {
            bootstrap.Tooltip.getOrCreateInstance(element, {
                placement: element.dataset.bsPlacement || "right",
                trigger: "hover focus"
            });
        });
    }

    function syncSidebarTooltips(collapsed) {
        disposeSidebarTooltips();
        if (collapsed && !isMobileSidebar()) enableSidebarTooltips();
    }

    function applySidebarState(collapsed) {
        sidebar.classList.toggle("is-collapsed", collapsed);
        content.classList.toggle("is-sidebar-collapsed", collapsed);
        document.documentElement.classList.toggle("sidebar-state-collapsed", collapsed);
        document.body.classList.toggle("sidebar-collapsed", collapsed);
        document.body.classList.toggle("sidebar-expanded", !collapsed);
        desktopToggleButtons.forEach((toggleButton) => {
            toggleButton.setAttribute("aria-expanded", (!collapsed).toString());
            toggleButton.setAttribute("aria-label", collapsed ? t("sidebar.expand", {}, "Menü ausklappen") : t("sidebar.collapse", {}, "Menü einklappen"));
            toggleButton.dataset.bsTitle = collapsed ? t("sidebar.expand", {}, "Menü ausklappen") : t("sidebar.collapse", {}, "Menü einklappen");
        });

        syncSidebarTooltips(collapsed);
    }

    function applyMobileSidebarState(open) {
        sidebar.classList.toggle("expanded", open);
        content.classList.toggle("expanded-content", open);
        document.body.classList.toggle("sidebar-mobile-open", open);

        if (mobileBackdrop) {
            if (open) mobileBackdrop.hidden = false;
            mobileBackdrop.classList.toggle("is-visible", open);

            if (!open) {
                window.setTimeout(() => {
                    if (!mobileBackdrop.classList.contains("is-visible")) mobileBackdrop.hidden = true;
                }, 220);
            }
        }

        mobileToggleButtons.forEach((toggleButton) => {
            toggleButton.setAttribute("aria-expanded", open.toString());
            toggleButton.setAttribute("aria-label", open ? t("sidebar.close", {}, "Menü schließen") : t("sidebar.open", {}, "Menü öffnen"));
        });

        desktopToggleButtons.forEach((toggleButton) => {
            if (!isMobileSidebar()) return;

            toggleButton.setAttribute("aria-expanded", open.toString());
            toggleButton.setAttribute("aria-label", open ? t("sidebar.close", {}, "Menü schließen") : t("sidebar.open", {}, "Menü öffnen"));
            toggleButton.dataset.bsTitle = open ? t("sidebar.close", {}, "Menü schließen") : t("sidebar.open", {}, "Menü öffnen");
        });
    }

    applySidebarState(sidebarIsCollapsed());
    applyMobileSidebarState(false);

    desktopToggleButtons.forEach((toggleButton) => {
        if (toggleButton.dataset.sidebarBound === "true") return;

        toggleButton.dataset.sidebarBound = "true";
        toggleButton.addEventListener("click", function () {
            if (isMobileSidebar()) {
                applyMobileSidebarState(!sidebar.classList.contains("expanded"));
                return;
            }

            const collapsed = !sidebar.classList.contains("is-collapsed");
            persistSidebarState(collapsed);
            applySidebarState(collapsed);
        });
    });

    mobileToggleButtons.forEach((toggleButton) => {
        if (toggleButton.dataset.sidebarBound === "true") return;

        toggleButton.dataset.sidebarBound = "true";
        toggleButton.addEventListener("click", function () {
            applyMobileSidebarState(!sidebar.classList.contains("expanded"));
        });
    });

    if (mobileBackdrop && mobileBackdrop.dataset.sidebarBackdropBound !== "true") {
        mobileBackdrop.dataset.sidebarBackdropBound = "true";
        mobileBackdrop.addEventListener("click", function () {
            applyMobileSidebarState(false);
        });
    }

    if (sidebar.dataset.mobileLinksBound !== "true") {
        sidebar.dataset.mobileLinksBound = "true";
        sidebar.querySelectorAll("a[href]").forEach((link) => {
            link.addEventListener("click", function () {
                if (!isMobileSidebar()) return;
                if (link.getAttribute("href") === "#") return;

                applyMobileSidebarState(false);
            });
        });
    }

    if (document.body.dataset.sidebarKeyboardBound !== "true") {
        document.body.dataset.sidebarKeyboardBound = "true";
        document.addEventListener("keydown", function (event) {
            if (event.key !== "Escape" || !isMobileSidebar()) return;
            applyMobileSidebarState(false);
        });
    }

    if (document.body.dataset.sidebarViewportBound !== "true") {
        document.body.dataset.sidebarViewportBound = "true";
        const resetMobileState = function () {
            if (!isMobileSidebar()) applyMobileSidebarState(false);
        };

        if (mobileMediaQuery.addEventListener) {
            mobileMediaQuery.addEventListener("change", resetMobileState);
        } else if (mobileMediaQuery.addListener) {
            mobileMediaQuery.addListener(resetMobileState);
        }
    }
}

document.addEventListener("turbolinks:load", initializeSidebarState);
document.addEventListener("DOMContentLoaded", initializeSidebarState);
document.addEventListener("htmx:load", initializeSidebarState);
document.addEventListener('turbolinks:load', function () {
    let loadMore = document.getElementById('load-more');

    // 1) Infinite-scroll logic
    window.addEventListener('scroll', function () {
        // If the #load-more button exists and we're within 100px of the bottom:
        if (loadMore && window.scrollY + window.innerHeight > document.documentElement.scrollHeight - 100) {
            loadMore.click(); // programmatically click the button to load more leads
        }
    });

    // 2) Show a spinner when the #load-more button is clicked
    document.addEventListener('click', function (event) {
        if (event.target && event.target.id === 'load-more') {
            event.target.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Loading...';
        }
    });
});


function update_slider() {
    // Apply Choices.js to select elements with the "choices-select" class
    const confidenceRange = document.getElementById('confidenceRange');
    const confidenceValue = document.getElementById('confidenceValue');
    if (!confidenceRange || !confidenceValue) return;

    // Update the displayed value when the slider moves
    confidenceRange.addEventListener('input', function() {
        confidenceValue.textContent =  ' ' + (this.value * 100).toFixed(0) + ' ';
    });
}

document.addEventListener('htmx:afterOnLoad', update_slider);
document.addEventListener('htmx:afterSwap', update_slider);
document.addEventListener('htmx:afterSettle', update_slider);
document.addEventListener('htmx:load', update_slider);
document.addEventListener('turbolinks:load', update_slider);

function update_slider_2() {
    // Apply Choices.js to select elements with the "choices-select" class
    const confidenceRange = document.getElementById('stammkapitalRange');
    const confidenceValue = document.getElementById('stammkapitalValue');
    if (!confidenceRange || !confidenceValue) return;

    // Update the displayed value when the slider moves
    confidenceRange.addEventListener('input', function() {
        confidenceValue.textContent = ' ' + this.value + ' ';
    });
}

document.addEventListener('htmx:afterOnLoad', update_slider_2);
document.addEventListener('htmx:afterSwap', update_slider_2);
document.addEventListener('htmx:afterSettle', update_slider_2);
document.addEventListener('htmx:load', update_slider_2);
document.addEventListener('turbolinks:load', update_slider_2);

function initializeSmartSearch() {
    const inputs = document.querySelectorAll("[data-smart-search-input]");

    inputs.forEach((input) => {
        if (input.dataset.smartSearchReady === "true") return;
        input.dataset.smartSearchReady = "true";

        const wrapper = input.closest(".smart-search") || input.parentElement;
        const panel = wrapper.querySelector("[data-smart-search-results]");
        const status = wrapper.querySelector("[data-smart-search-status]");
        const minLength = parseInt(input.dataset.smartSearchMinLength || "2", 10);
        let timer = null;
        let controller = null;
        let activeIndex = -1;

        function escapeHtml(value) {
            const div = document.createElement("div");
            div.textContent = value || "";
            return div.innerHTML;
        }

        function suggestionLinks() {
            return panel ? Array.from(panel.querySelectorAll(".smart-search__item")) : [];
        }

        function setActiveIndex(index) {
            const links = suggestionLinks();
            links.forEach((link) => link.classList.remove("is-active"));
            activeIndex = index;

            if (links[activeIndex]) {
                links[activeIndex].classList.add("is-active");
                links[activeIndex].scrollIntoView({ block: "nearest" });
            }
        }

        function hidePanel() {
            if (panel) {
                panel.innerHTML = "";
                panel.hidden = true;
            }
            activeIndex = -1;
        }

        function renderResults(data) {
            if (!panel) return;

            const suggestions = data.suggestions || [];
            if (suggestions.length === 0) {
                panel.innerHTML = `<div class="smart-search__empty">${escapeHtml(t("smart_search.no_suggestions", {}, "Keine Vorschläge gefunden"))}</div>`;
                panel.hidden = false;
                return;
            }

            const summary = data.projects_count
                ? t("smart_search.summary_with_projects", { count: data.count || 0, projects: data.projects_count }, `${data.count || 0} Leads · ${data.projects_count} Projekte`)
                : t("smart_search.summary_hits", { count: data.count || 0 }, `${data.count || 0} Treffer`);

            panel.innerHTML = `
                <div class="smart-search__summary">${escapeHtml(summary)}</div>
                ${suggestions.map((item) => `
                    <a class="smart-search__item" href="${escapeHtml(item.url)}">
                        <span class="smart-search__icon"><i class="fa-solid ${escapeHtml(item.icon || "fa-magnifying-glass")}"></i></span>
                        <span class="smart-search__copy">
                            <span class="smart-search__type">${escapeHtml(item.type)}</span>
                            <strong>${escapeHtml(item.title)}</strong>
                            ${item.subtitle ? `<small>${escapeHtml(item.subtitle)}</small>` : ""}
                        </span>
                    </a>
                `).join("")}
            `;
            panel.hidden = false;
            setActiveIndex(-1);
        }

        function updateStatus(data) {
            if (!status) return;

            if (!data || input.value.trim().length < minLength) {
                status.textContent = "";
                return;
            }

            status.textContent = data.projects_count
                ? t("smart_search.status_with_projects", { count: data.count || 0, projects: data.projects_count }, `${data.count || 0} Treffer, ${data.projects_count} Projekte`)
                : t("smart_search.summary_hits", { count: data.count || 0 }, `${data.count || 0} Treffer`);
        }

        function fetchSuggestions() {
            const query = input.value.trim();
            const url = input.dataset.smartSearchUrl;

            if (!url || query.length < minLength) {
                hidePanel();
                updateStatus(null);
                return;
            }

            if (controller) controller.abort();
            controller = new AbortController();
            if (status) status.textContent = t("smart_search.loading", {}, "Suche läuft...");

            fetch(`${url}?q=${encodeURIComponent(query)}`, {
                headers: { "Accept": "application/json" },
                signal: controller.signal
            })
                .then((response) => response.json())
                .then((data) => {
                    if (input.value.trim() !== query) return;
                    renderResults(data);
                    updateStatus(data);
                })
                .catch((error) => {
                    if (error.name === "AbortError") return;
                    hidePanel();
                    if (status) status.textContent = t("smart_search.unavailable", {}, "Suche aktuell nicht verfügbar");
                });
        }

        input.addEventListener("input", function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(fetchSuggestions, 220);
        });

        input.addEventListener("keydown", function (event) {
            const links = suggestionLinks();
            if (panel && !panel.hidden && links.length > 0) {
                if (event.key === "ArrowDown") {
                    event.preventDefault();
                    setActiveIndex((activeIndex + 1) % links.length);
                } else if (event.key === "ArrowUp") {
                    event.preventDefault();
                    setActiveIndex((activeIndex - 1 + links.length) % links.length);
                } else if (event.key === "Enter" && activeIndex >= 0) {
                    event.preventDefault();
                    window.location.href = links[activeIndex].href;
                } else if (event.key === "Escape") {
                    hidePanel();
                }
            }
        });

        input.addEventListener("focus", function () {
            if (input.value.trim().length >= minLength && panel && panel.innerHTML.trim().length > 0) {
                panel.hidden = false;
            }
        });

        document.addEventListener("click", function (event) {
            if (!wrapper.contains(event.target)) hidePanel();
        });
    });
}

window.initializeSmartSearch = initializeSmartSearch;

document.addEventListener("turbolinks:load", initializeSmartSearch);
document.addEventListener("htmx:afterSwap", initializeSmartSearch);
document.addEventListener("htmx:load", initializeSmartSearch);

function projectWorkspaceRoot() {
    return document.querySelector("[data-project-live-root]") || document;
}

function projectSelectableCheckboxes(root = projectWorkspaceRoot()) {
    return Array.from(root.querySelectorAll(".lead-checkbox")).filter((checkbox) => !checkbox.disabled);
}

function setProjectSelection(root, checked) {
    projectSelectableCheckboxes(root).forEach((checkbox) => {
        checkbox.checked = checked;
    });
    updateProjectTaskControls();
}

function syncProjectSelectableState(root = projectWorkspaceRoot()) {
    projectSelectableCheckboxes(root).forEach((checkbox) => {
        const row = checkbox.closest(".project-lead-row");
        const card = checkbox.closest(".project-kanban-card");
        if (row) row.classList.toggle("is-selected", checkbox.checked);
        if (card) card.classList.toggle("is-selected", checkbox.checked);
    });
}

function projectSelectionClickIsInteractive(target) {
    return Boolean(target.closest("a, button, input, select, textarea, label, .choices, [data-project-filter-remove], [data-project-quick-filter], [data-bs-toggle], [hx-get], [data-hx-get]"));
}

function initializeProjectScoutingDropdown() {
    document.querySelectorAll(".project-scouting-dropdown").forEach((dropdown) => {
        if (dropdown.dataset.scoutingDropdownBound === "true") return;

        const actions = dropdown.closest(".project-workspace__actions");
        const syncOpenState = (isOpen) => {
            dropdown.classList.toggle("is-open", isOpen);
            if (actions) actions.classList.toggle("is-scouting-menu-open", isOpen);
        };

        dropdown.dataset.scoutingDropdownBound = "true";
        dropdown.addEventListener("show.bs.dropdown", () => syncOpenState(true));
        dropdown.addEventListener("hidden.bs.dropdown", () => syncOpenState(false));
    });
}

function updateProjectTaskControls() {
    const root = projectWorkspaceRoot();
    const controls = document.getElementById("task-controls");
    const countElement = document.getElementById("selected-leads-count");
    const promptField = document.getElementById("prompt-field");
    const tagField = document.getElementById("tag-field");
    const taskSelect = document.getElementById("task-select");
    const submitButton = document.querySelector("[data-project-bulk-submit]");
    const taskHelpItems = document.querySelectorAll("[data-project-task-help]");
    const checkboxes = projectSelectableCheckboxes(root);
    const selectedCount = checkboxes.filter((checkbox) => checkbox.checked).length;
    const selectedTask = taskSelect ? taskSelect.value : "";
    const allSelected = checkboxes.length > 0 && selectedCount === checkboxes.length;
    const submitLabels = {
        enrich_leads: t("project.bulk.enrich_leads", {}, "Daten anreichern"),
        find_emails: t("project.bulk.find_emails", {}, "Emails suchen"),
        start_a_campaign: t("project.bulk.start_campaign", {}, "Kampagne erstellen"),
        create_next_task: t("project.bulk.create_next_task", {}, "To-dos erstellen"),
        apply_tag: t("project.bulk.apply_tag", {}, "Tag hinzufügen"),
        delete_leads: t("project.bulk.delete_leads", {}, "Auswahl löschen")
    };

    syncProjectSelectableState(root);

    root.querySelectorAll("[data-project-select-all]").forEach((checkbox) => {
        checkbox.checked = allSelected;
        checkbox.indeterminate = selectedCount > 0 && !allSelected;
    });

    if (countElement) countElement.textContent = selectedCount;
    if (controls) controls.hidden = selectedCount === 0;
    if (promptField) promptField.hidden = selectedTask !== "start_a_campaign";
    if (tagField) tagField.hidden = selectedTask !== "apply_tag";
    taskHelpItems.forEach((item) => {
        item.hidden = item.dataset.projectTaskHelp !== selectedTask;
    });
    if (submitButton) {
        submitButton.classList.toggle("btn--danger", selectedTask === "delete_leads");
        submitButton.value = submitLabels[selectedTask] || "Aktion ausf\u00fchren";
        submitButton.disabled = selectedCount === 0;
    }
}

function insertProjectCampaignPrompt(text) {
    const promptInput = document.querySelector("[data-project-campaign-prompt]");
    const prompt = String(text || "").trim();

    if (!promptInput || !prompt) return;

    const prefix = promptInput.value.trim().length > 0 ? "\n\n" : "";
    promptInput.value = `${promptInput.value}${prefix}${prompt}`;
    promptInput.focus();
    promptInput.dispatchEvent(new Event("input", { bubbles: true }));
}

function initializeProjectTagComposer() {
    document.querySelectorAll("[data-project-tag-composer]").forEach((composer) => {
        if (composer.dataset.projectTagComposerReady === "true") return;
        composer.dataset.projectTagComposerReady = "true";

        const input = composer.querySelector("[data-project-tag-input]");
        if (input) window.setTimeout(() => input.focus(), 40);
    });
}

function initializeProjectLiveFilters() {
    const root = document.querySelector("[data-project-live-root]");
    const frame = document.querySelector("[data-project-live-frame]");
    if (!root || !frame || root.dataset.projectLiveReady === "true") return;

    root.dataset.projectLiveReady = "true";

    const form = root.querySelector("[data-project-live-form]");
    let timer = null;
    let controller = null;
    let paginationController = null;
    let paginationObserver = null;
    let paginationLoading = false;

    function liveUrlFromForm() {
        const url = new URL(form.action, window.location.origin);
        const formData = new FormData(form);
        formData.append("live", "1");

        formData.forEach((value, key) => {
            if (String(value).trim() !== "") url.searchParams.append(key, value);
        });

        return url;
    }

    function cleanBrowserUrl(url) {
        const browserUrl = new URL(url.toString());
        browserUrl.searchParams.delete("live");
        browserUrl.searchParams.delete("clear_filters");
        return browserUrl.pathname + browserUrl.search;
    }

    function refresh(url, pushState = true) {
        if (!url) url = liveUrlFromForm();
        if (controller) controller.abort();
        if (paginationController) paginationController.abort();
        if (paginationObserver) paginationObserver.disconnect();
        controller = new AbortController();
        root.classList.add("is-loading");

        url.searchParams.set("live", "1");

        fetch(url.toString(), {
            headers: {
                "Accept": "text/html",
                "X-Requested-With": "XMLHttpRequest"
            },
            signal: controller.signal
        })
            .then((response) => {
                if (!response.ok) throw new Error(`Live update failed: ${response.status}`);
                return response.text();
            })
            .then((html) => {
                frame.innerHTML = html;
                if (pushState) window.history.replaceState({}, "", cleanBrowserUrl(url));
                initializechoicesselect();
                initializeSmartSearch();
                initializeProjectLiveFilters();
                updateProjectTaskControls();
            })
            .catch((error) => {
                if (error.name === "AbortError") return;
                root.classList.remove("is-loading");
                const count = root.querySelector("[data-project-live-count]");
                if (count) count.innerHTML = "<strong>!</strong> Update fehlgeschlagen";
            });
    }

    function refreshSoon(delay = 260) {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => refresh(), delay);
    }

    function setPaginationLoading(pagination, loading) {
        if (!pagination) return;

        const link = pagination.querySelector("[data-project-pagination-link]");
        const loadingIndicator = pagination.querySelector("[data-project-pagination-loading]");

        pagination.classList.toggle("is-loading", loading);
        if (link) link.hidden = loading;
        if (loadingIndicator) loadingIndicator.hidden = !loading;
    }

    function setupPaginationObserver() {
        if (paginationObserver) paginationObserver.disconnect();

        const pagination = root.querySelector("[data-project-pagination]");
        const sentinel = root.querySelector("[data-project-pagination-sentinel]");
        const link = pagination ? pagination.querySelector("[data-project-pagination-link]") : null;

        if (!pagination || !sentinel || !link || !("IntersectionObserver" in window)) return;

        const observerRoot = window.matchMedia("(max-width: 768px)").matches ? null : root.querySelector(".project-table-wrap");

        paginationObserver = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) loadNextPage(link);
        }, {
            root: observerRoot,
            rootMargin: "240px 0px",
            threshold: 0.01
        });

        paginationObserver.observe(sentinel);
    }

    function loadNextPage(link) {
        if (!link || paginationLoading) return;

        const pagination = link.closest("[data-project-pagination]");
        const targetId = pagination ? pagination.dataset.projectPaginationTarget : null;
        const target = targetId ? root.querySelector(`#${targetId}`) : null;
        if (!pagination || !target) return;

        if (paginationObserver) paginationObserver.disconnect();
        if (paginationController) paginationController.abort();

        const url = new URL(link.href, window.location.origin);
        url.searchParams.set("live", "1");
        url.searchParams.set("pagination", "1");

        paginationLoading = true;
        paginationController = new AbortController();
        setPaginationLoading(pagination, true);

        fetch(url.toString(), {
            headers: {
                "Accept": "text/html",
                "X-Requested-With": "XMLHttpRequest"
            },
            signal: paginationController.signal
        })
            .then((response) => {
                if (!response.ok) throw new Error(`Pagination failed: ${response.status}`);
                return response.text();
            })
            .then((html) => {
                const doc = new DOMParser().parseFromString(html, "text/html");
                const rowContainer = doc.querySelector("[data-project-pagination-rows]");
                const nextPagination = doc.querySelector("[data-project-pagination]");

                if (rowContainer) {
                    target.querySelectorAll("[data-project-pagination-sentinel]").forEach((sentinel) => sentinel.remove());
                    Array.from(rowContainer.children).forEach((row) => {
                        target.appendChild(document.importNode(row, true));
                    });
                }

                if (nextPagination) {
                    pagination.replaceWith(document.importNode(nextPagination, true));
                } else {
                    pagination.remove();
                }

                if (window.htmx) window.htmx.process(target);
                initializeProjectTagComposer();
                updateProjectTaskControls();
                paginationLoading = false;
                setupPaginationObserver();
            })
            .catch((error) => {
                paginationLoading = false;
                if (error.name === "AbortError") return;
                console.error(error);
                setPaginationLoading(pagination, false);
            });
    }

    function fieldSelector(field) {
        return `[name="q[${field}]"], [name="q[${field}][]"]`;
    }

    function removeFilter(field, value) {
        const element = form.querySelector(fieldSelector(field));
        if (!element) return;

        if (element.tagName === "SELECT") {
            Array.from(element.options).forEach((option) => {
                if (option.value === value) option.selected = false;
            });
        } else {
            element.value = "";
        }

        element.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function addQuickFilter(field, value) {
        const element = form.querySelector(fieldSelector(field));
        if (!element) return;

        if (element.tagName === "SELECT") {
            Array.from(element.options).forEach((option) => {
                if (option.value === String(value)) option.selected = true;
            });
        } else {
            element.value = value;
        }

        element.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (form) {
        form.addEventListener("submit", (event) => {
            event.preventDefault();
            refresh();
        });

        form.addEventListener("input", (event) => {
            if (event.target.matches("[data-smart-search-input]")) refreshSoon(260);
        });

        form.addEventListener("change", () => refreshSoon(80));
    }

    root.addEventListener("click", (event) => {
        const selectAllLoaded = event.target.closest("[data-project-select-all-loaded]");
        if (selectAllLoaded) {
            event.preventDefault();
            setProjectSelection(root, true);
            return;
        }

        const clearSelection = event.target.closest("[data-project-clear-selection]");
        if (clearSelection) {
            event.preventDefault();
            setProjectSelection(root, false);
            return;
        }

        const bulkSubmit = event.target.closest("[data-project-bulk-submit]");
        if (bulkSubmit) {
            const taskSelect = document.getElementById("task-select");
            const selectedCount = projectSelectableCheckboxes(root).filter((checkbox) => checkbox.checked).length;
            if (taskSelect && taskSelect.value === "delete_leads" && !window.confirm(t("project.bulk.delete_confirm", { count: selectedCount }, `${selectedCount} ausgewählte Einträge wirklich löschen?`))) {
                event.preventDefault();
                return;
            }
        }

        const selectableCardOrRow = event.target.closest(".project-lead-row, .project-kanban-card");
        if (selectableCardOrRow && !projectSelectionClickIsInteractive(event.target)) {
            const checkbox = selectableCardOrRow.querySelector(".lead-checkbox:not(:disabled)");
            if (checkbox) {
                event.preventDefault();
                checkbox.checked = !checkbox.checked;
                updateProjectTaskControls();
                return;
            }
        }

        const viewButton = event.target.closest("[data-project-view]");
        if (viewButton && form) {
            event.preventDefault();
            const viewField = form.querySelector("[data-project-view-field]");
            if (viewField) viewField.value = viewButton.dataset.projectView;
            refresh(liveUrlFromForm());
            return;
        }

        const perspectiveButton = event.target.closest("[data-project-perspective]");
        if (perspectiveButton && form) {
            event.preventDefault();
            const perspectiveField = form.querySelector("[data-project-perspective-field]");
            if (perspectiveField) perspectiveField.value = perspectiveButton.dataset.projectPerspective;
            refresh(liveUrlFromForm());
            return;
        }

        const removeButton = event.target.closest("[data-project-filter-remove]");
        if (removeButton && form) {
            event.preventDefault();
            removeFilter(removeButton.dataset.field, removeButton.dataset.value);
            return;
        }

        const quickFilter = event.target.closest("[data-project-quick-filter]");
        if (quickFilter && form) {
            event.preventDefault();
            addQuickFilter(quickFilter.dataset.field, quickFilter.dataset.value);
            return;
        }

        const clearLink = event.target.closest("[data-project-live-clear]");
        if (clearLink) {
            event.preventDefault();
            const url = new URL(clearLink.href, window.location.origin);
            url.searchParams.set("live", "1");
            refresh(url);
            return;
        }

        const paginationLink = event.target.closest("[data-project-pagination-link]");
        if (paginationLink) {
            event.preventDefault();
            loadNextPage(paginationLink);
            return;
        }

        const liveLink = event.target.closest("[data-project-live-link]");
        if (liveLink) {
            event.preventDefault();
            const url = new URL(liveLink.href, window.location.origin);
            url.searchParams.set("live", "1");
            refresh(url);
        }
    });

    updateProjectTaskControls();
    setupPaginationObserver();
}

document.addEventListener("change", (event) => {
    const selectedMailOption = event.target.closest(".project-mail-option");
    if (selectedMailOption && event.target.matches(".project-mail-option__choice .form-check-input[type='radio']")) {
        const mailOptions = selectedMailOption.closest(".project-mail-options");
        if (mailOptions) {
            mailOptions.querySelectorAll(".project-mail-option").forEach((option) => {
                option.classList.toggle("is-active", option === selectedMailOption);
            });
        }
    }

    const campaignTextBlockSelect = event.target.closest("[data-project-text-block-select]");
    if (campaignTextBlockSelect) {
        insertProjectCampaignPrompt(campaignTextBlockSelect.value);
        campaignTextBlockSelect.value = "";
        return;
    }

    if (event.target.matches("[data-project-select-all]")) {
        const root = event.target.closest("[data-project-live-root]") || projectWorkspaceRoot();
        setProjectSelection(root, event.target.checked);
        return;
    }

    if (event.target.matches(".lead-checkbox, #task-select")) updateProjectTaskControls();
});

document.addEventListener("click", (event) => {
    const campaignPromptButton = event.target.closest("[data-project-prompt-template]");
    if (campaignPromptButton) {
        event.preventDefault();
        insertProjectCampaignPrompt(campaignPromptButton.dataset.projectPromptTemplate);
        return;
    }

    const closeButton = event.target.closest("[data-project-tag-editor-close]");
    if (!closeButton) return;

    event.preventDefault();
    const slot = closeButton.closest(".project-tag-add-slot");
    if (!slot) return;

    const leadId = closeButton.dataset.leadId;
    const newTagUrl = closeButton.dataset.newTagUrl;
    slot.innerHTML = `
        <a class="project-tag-add" href="#" hx-get="${newTagUrl}" hx-target="#addTag_${leadId}" hx-trigger="click" hx-swap="innerHTML" title="${t("project.tags.add_title", {}, "Tag hinzufügen")}" aria-label="${t("project.tags.add_title", {}, "Tag hinzufügen")}">
            <i class="fa fa-plus"></i>
        </a>
    `;
    if (window.htmx) window.htmx.process(slot);
});

document.addEventListener("turbolinks:load", initializeProjectLiveFilters);
document.addEventListener("htmx:afterSwap", initializeProjectLiveFilters);
document.addEventListener("htmx:load", initializeProjectLiveFilters);
document.addEventListener("turbolinks:load", initializeProjectScoutingDropdown);
document.addEventListener("htmx:afterSwap", initializeProjectScoutingDropdown);
document.addEventListener("htmx:load", initializeProjectScoutingDropdown);
document.addEventListener("turbolinks:load", initializeProjectTagComposer);
document.addEventListener("htmx:afterSwap", initializeProjectTagComposer);
document.addEventListener("htmx:load", initializeProjectTagComposer);

require("@rails/actiontext")
import "controllers"
